type EnvSnapshot = Record<string, unknown>;

const readEnv = (): EnvSnapshot => ((import.meta as any)?.env ?? {}) as EnvSnapshot;

export const getEnvBoolean = (key: string, defaultValue = false): boolean => {
  const env = readEnv();
  const raw = env[key];
  if (raw === undefined || raw === null || raw === "") return defaultValue;
  if (typeof raw === "boolean") return raw;
  const normalized = String(raw).trim().toLowerCase();
  if (["true", "1", "yes", "y"].includes(normalized)) return true;
  if (["false", "0", "no", "n"].includes(normalized)) return false;
  return defaultValue;
};

export const isSuggestionsV2Enabled = (): boolean =>
  getEnvBoolean("VITE_SUGGESTIONS_V2", true); // Default V2 in prod

export const isSuggestionsV2PreferServerMerged = (): boolean =>
  getEnvBoolean("VITE_SUGGESTIONS_V2_PREFER_SERVER_MERGED", false);
